module.exports = __webpack_public_path__ + "static/media/simulation-select-fixed-value.ab76a3ed.svg";